import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalendarEdit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCalendarEdit"><Path d="M20.5 8.5H3.5M20.5 8.5V4.5H3.5V8.5M20.5 8.5V11.5M3.5 8.5V20.5H11.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 4.5V2.5" stroke="currentColor" strokeLinecap="square"/><Path d="M16.5 4.5V2.5" stroke="currentColor" strokeLinecap="square"/><Path d="M21.5 16.5L16.5 21.5H14.5V19.3889L19.5 14.5L21.5 16.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCalendarEdit;
